import { createFileRoute } from "@tanstack/react-router";
import { SearchTermsPage } from "~/pages/search-terms/search-terms-page";

export const Route = createFileRoute("/_app/search-terms/")({
  component: SearchTermsPage,
});
